import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiCheck, FiMail, FiClock, FiStar } from 'react-icons/fi';
import ScrollToTop from '../utils/ScrollToTop';

export default function SuccessStep() {
  return (
    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="max-w-4xl mx-auto pt-12 pb-24 text-center">
      <ScrollToTop />
      <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-emerald-500/10 border border-emerald-500/20 text-emerald-400 text-xs font-black mb-8 tracking-[0.2em] uppercase">
        <SafeIcon icon={FiStar} />
        <span>Anfrage erfolgreich</span>
      </div>
      <h2 className="text-5xl md:text-7xl font-black text-white mb-8 tracking-tighter leading-tight">
        Deine Mission <br />
        <span className="text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-teal-400 italic font-serif">ist gestartet.</span>
      </h2>
      <p className="text-xl text-slate-300 max-w-2xl mx-auto mb-16 leading-relaxed">
        Vielen Dank für dein Vertrauen. Wir haben deine kognitiven Daten erhalten und bereiten nun die nächsten Schritte für deine Strategie vor.
      </p>
      <div className="grid md:grid-cols-3 gap-8 mb-20 text-left">
        {[
          { icon: FiMail, title: "Posteingang prüfen", desc: "In den nächsten 48h erhältst du eine E-Mail mit deiner Auswertung, weiteren Informationen und einigen relevanten Fragen." },
          { icon: FiClock, title: "Planungs-Phase", desc: "Unter Berücksichtigung deiner persönlichen Gegebenheiten wird dein persönlicher 6-Wochen-Challenge-Plan aufgestellt." },
          { icon: FiCheck, title: "Dein Start", desc: "Nach Erhalt deines persönlichen 6-Wochen-Boards und des ersten Termins solltest du loslegen. Nach dem ersten Termin erhältst du die Challenge-Rechnung." },
        ].map((item, i) => (
          <div key={i} className="bg-slate-800/40 border border-slate-700/50 p-8 rounded-[32px] flex flex-col h-full">
            <div className="w-12 h-12 bg-blue-500/10 rounded-2xl flex items-center justify-center text-blue-400 mb-6 shrink-0">
              <SafeIcon icon={item.icon} size={24} />
            </div>
            <h3 className="text-white font-bold mb-3">{item.title}</h3>
            <p className="text-slate-400 text-sm leading-relaxed">{item.desc}</p>
          </div>
        ))}
      </div>
      <div className="p-12 bg-slate-50 border border-white rounded-[48px] shadow-2xl relative overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-emerald-400 to-teal-400" />
        <p className="text-slate-700 text-xl mb-10 italic font-medium leading-relaxed max-w-2xl mx-auto">
          "6 Wochen mit DigiLernFlow und mit 6 festen Begleitterminen á 1 Stunde werden deine Art und Weise des Lernens verändern. Wir freuen uns, dich dabei zu begleiten."
        </p>
        <div className="flex flex-col items-center gap-6">
          <img src="https://kanban.digikreide-kurse.de/logo.png" alt="Logo" className="h-12 w-auto object-contain" />
          <div className="flex items-center gap-4">
            <div className="h-[1px] w-8 bg-slate-300" />
            <span className="text-slate-500 font-black text-xs uppercase tracking-[0.3em]">MatheMission Team</span>
            <div className="h-[1px] w-8 bg-slate-300" />
          </div>
        </div>
      </div>
    </motion.div>
  );
}